module.exports = __webpack_public_path__ + "static/img/product_qmz.9ef9f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/product_qmz.png
// module id = p8Ml
// module chunks = 0